import { InView } from 'react-intersection-observer'
import CountUp from 'react-countup'

const easeOutCubic = (t, b, c, d) => {
  return c * ((t = t / d - 1) * t * t + 1) + b
}

const CountUpSp = ({
  className = '',
  start = 0,
  end,
  duration = 2,
  countUpProps,
  numberProps,
}) => {
  return (
    <CountUp
      start={start}
      end={end}
      duration={duration}
      separator=","
      useEasing
      easingFn={easeOutCubic}
      {...countUpProps}
    >
      {({ countUpRef, start }) => (
        <InView as="span" triggerOnce onChange={(inView, entry) => start()}>
          <span ref={countUpRef} className={className} {...numberProps} />
        </InView>
      )}
    </CountUp>
  )
}

export default CountUpSp
